import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoUser16 = t0 => {
  const $ = _c(11);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M10.499 4.33334C10.499 5.71406 9.37973 6.83334 7.999 6.83334C6.61831 6.83334 5.49902 5.71406 5.49902 4.33334C5.49902 2.95263 6.61831 1.83334 7.999 1.83334C9.37973 1.83334 10.499 2.95263 10.499 4.33334Z" />;
    t3 = <path d="M7.99916 8.83334C5.46878 8.83334 3.6218 10.5157 3.11356 12.7771C3.02742 13.1604 3.33863 13.5 3.73147 13.5H12.2669C12.6598 13.5 12.971 13.1604 12.8848 12.7771C12.3766 10.5157 10.5296 8.83334 7.99916 8.83334Z" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== iconColor) {
    t4 = <g stroke={iconColor} strokeWidth={1.5} strokeLinejoin="round">{t2}{t3}</g>;
    $[4] = iconColor;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== ariaLabel || $[8] !== className || $[9] !== t4) {
    t6 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t4}{t5}</svg>;
    $[7] = ariaLabel;
    $[8] = className;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default IcoUser16;